export function debounce(fn, delay) {
    let timeoutID = null;
    return function debounce(...args) {
        clearTimeout(timeoutID);
        const that = this;
        timeoutID = setTimeout(() => {
            fn.apply(that, args);
        }, delay);
    };
}
